import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './locales/fr.json';
import en from './locales/en.json';
import es from './locales/es.json';
import it from './locales/it.json';

export const SUPPORTED_LANGS = ['fr', 'en', 'es', 'it'];

export const getLangFromPath = (pathname) => {
  const m = (pathname || '').match(/^\/(en|es|it)(\/|$)/);
  return m ? m[1] : 'fr';
};

export const currentLang = getLangFromPath(window.location.pathname);
export const langBasename = currentLang === 'fr' ? '/' : `/${currentLang}`;

export const buildLangUrl = (lang, pathname, search = '') => {
  const clean = (pathname || '/').replace(/^\/(en|es|it)(?=\/|$)/, '') || '/';
  const prefix = lang === 'fr' ? '' : `/${lang}`;
  return `${prefix}${clean}${search}`;
};

i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr },
    en: { translation: en },
    es: { translation: es },
    it: { translation: it },
  },
  lng: currentLang,
  fallbackLng: 'fr',
  interpolation: { escapeValue: false },
});

if (currentLang !== 'fr' && localStorage.getItem('padsmash_lang') !== currentLang) {
  localStorage.setItem('padsmash_lang', currentLang);
}

export default i18n;
